/**
 * @generated SignedSource<<9e4b43977a917592f815d5aef26f5224>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DiskCleanerInput = {
  media?: DiskCleanerMediaInput | null;
  storage?: DiskCleanerStorageInput | null;
};
export type DiskCleanerMediaInput = {
  selected?: boolean | null;
};
export type DiskCleanerStorageInput = {
  selected?: boolean | null;
};
export type ToolsDiskCleanupPageQuery$variables = {
  input?: DiskCleanerInput | null;
  scan?: boolean | null;
};
export type ToolsDiskCleanupPageQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"DiskCleanup_data">;
};
export type ToolsDiskCleanupPageQuery = {
  response: ToolsDiskCleanupPageQuery$data;
  variables: ToolsDiskCleanupPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  },
  {
    "defaultValue": false,
    "kind": "LocalArgument",
    "name": "scan"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "count",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "size",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ToolsDiskCleanupPageQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "DiskCleanup_data"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ToolsDiskCleanupPageQuery",
    "selections": [
      {
        "condition": "scan",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "input",
                "variableName": "input"
              }
            ],
            "concreteType": "DiskCleanerResult",
            "kind": "LinkedField",
            "name": "diskCleanerScan",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CleanInfo",
                "kind": "LinkedField",
                "name": "media",
                "plural": false,
                "selections": (v1/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "CleanInfo",
                "kind": "LinkedField",
                "name": "storage",
                "plural": false,
                "selections": (v1/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "8653a1a31a9a9c2966beb262623773d3",
    "id": null,
    "metadata": {},
    "name": "ToolsDiskCleanupPageQuery",
    "operationKind": "query",
    "text": "query ToolsDiskCleanupPageQuery(\n  $input: DiskCleanerInput\n  $scan: Boolean = false\n) {\n  ...DiskCleanup_data\n}\n\nfragment DiskCleanupForm_data on Query {\n  ...DiskCleanupMedia_data\n  ...DiskCleanupStorage_data\n}\n\nfragment DiskCleanupMedia_data on Query {\n  diskCleanerScan(input: $input) @include(if: $scan) {\n    media {\n      ...DiskCleanupResult_cleanInfo\n    }\n  }\n}\n\nfragment DiskCleanupResult_cleanInfo on CleanInfo {\n  ...DiskCleanupScanInfo_scanInfo\n}\n\nfragment DiskCleanupScanInfo_scanInfo on CleanInfo {\n  count\n  size\n}\n\nfragment DiskCleanupStorage_data on Query {\n  diskCleanerScan(input: $input) @include(if: $scan) {\n    storage {\n      ...DiskCleanupResult_cleanInfo\n    }\n  }\n}\n\nfragment DiskCleanup_data on Query {\n  ...DiskCleanupForm_data\n}\n"
  }
};
})();

(node as any).hash = "a79529b5b862fcf8de649dc1319c2e65";

export default node;
